import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
const getPdf = (node, title) => {
  const A4_WIDTH = 592.28;
  const A4_HEIGHT = 841.89;
  document.documentElement.scrollTop = 0; // 恢复滚动条
  const imageWrapper = document.querySelector('#' + node); // 获取DOM
  const pageHeight = (imageWrapper.scrollWidth / A4_WIDTH) * A4_HEIGHT;
  const pItem = imageWrapper.querySelectorAll('.pdf');
  // 判断当前dom节点是不是处于A4页面底部
  const isSplit = (nodes, index, pageHeight) => {
    return !!(nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight &&
      nodes[index + 1] &&
      nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight);
  };
  // 解决分页字体分割问题
  for (let i = 0; i < pItem.length; i++) {
    const multiple = Math.ceil((pItem[i].offsetTop + pItem[i].offsetHeight) / pageHeight);
    if (isSplit(pItem, i, multiple * pageHeight)) {
      const divParent = pItem[i].parentNode; // 获取该div的父节点
      const newNode = document.createElement('div');
      newNode.className = 'emptyDiv';
      newNode.style.background = '#ffffff';
      const _H = multiple * pageHeight - (pItem[i].offsetTop + pItem[i].offsetHeight);
      // 留白
      newNode.style.height = _H + 180 + 'px';
      newNode.style.width = '100%';
      const next = pItem[i].nextSibling; // 获取div的下一个兄弟节点
      // 判断兄弟节点是否存在
      if (next) {
        // 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
        divParent.insertBefore(newNode, next);
      } else {
        // 不存在则直接添加到最后,appendChild默认添加到divParent的最后
        divParent.appendChild(newNode);
      }
    }
  }

  html2Canvas(imageWrapper, {
    allowTaint: true, // 开启跨域
    scale: 4, // 设置清晰度，数值越高越清晰，生成的图片越大
    useCORS: true,
    backgroundColor: '#FFF'
    // dpi: 350
  }).then(canvas => {
    const contentWidth = canvas.width;
    const contentHeight = canvas.height;
    // 一页pdf显示html页面生成的canvas高度;
    const pageHeight = (contentWidth / A4_WIDTH) * A4_HEIGHT;
    // 生成pdf的html页面高度
    let htmlHeight = contentHeight;
    // 页面偏移
    let position = 0;
    // a4纸的尺寸[A4_WIDTH,A4_HEIGHT]，html页面生成的canvas在pdf中图片的宽高
    const imgWidth = A4_WIDTH - 5;
    const imgHeight = (A4_WIDTH / contentWidth) * contentHeight;
    const pageData = canvas.toDataURL('image/jpeg', 1.0);
    // 2为上面的scale 缩放了2倍
    const PDF = new JsPDF('', 'pt', 'a4');
    //  有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
    //  当内容未超过pdf一页显示的范围，无需分页
    if (htmlHeight < pageHeight) {
      PDF.addImage(pageData, 'JPEG', 4, 0, imgWidth, imgHeight);
    } else {
      while (htmlHeight > 0) {
        PDF.addImage(pageData, 'JPEG', 4, position, imgWidth, imgHeight);
        htmlHeight -= pageHeight;
        position -= 841.89;
        if (htmlHeight > 0) {
          //  避免添加空白页
          PDF.addPage();
        }
      }
    }
    PDF.save(title + '.pdf');
  });
};
export {
  getPdf
};



// WEBPACK FOOTER //
// ./src/utils/exportPDF.js